module.exports = __webpack_public_path__ + "img/leave-timer.95cd3e3a.png";